import { useEffect } from "react";

function useEscapeKey(onEscape) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onEscape(); // Вызываем переданную функцию
      }
    };

    // Добавляем обработчик события
    window.addEventListener("keydown", handleKeyDown);

    // Убираем обработчик при размонтировании
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onEscape]); // Добавляем зависимость

  // Хук ничего не возвращает, только выполняет логику
}

export default useEscapeKey;
